import { put, call } from 'redux-saga/effects';
import { moduleCreateAPI, moduleSearchAPI, moduleUpdateAPI } from 'src/api/ModuleApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { MODULE_ACTIONS } from '../actions/ModuleActions';
import { toast } from 'react-toastify';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(moduleSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: MODULE_ACTIONS.MODULE_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: MODULE_ACTIONS.MODULE_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(moduleSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: MODULE_ACTIONS.MODULE_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(moduleCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Module Created")
        
        yield put({
            type: MODULE_ACTIONS.MODULE_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: MODULE_ACTIONS.MODULE_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: MODULE_ACTIONS.MODULE_UPSERT_ERROR,
        });
    }
}

function* update(ModuleId, payload) {
    try {
        yield call(moduleUpdateAPI, {
            ModuleId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Module deleted")
        }
        else{
            toast("Module updated")
        } 
        
        yield put({
            type: MODULE_ACTIONS.MODULE_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: MODULE_ACTIONS.MODULE_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(MODULE_ACTIONS.MODULE_SEARCH, search),
    takeFirstSagaUtil(MODULE_ACTIONS.MODULE_UPSERT, upsert),
    takeFirstSagaUtil(MODULE_ACTIONS.MODULE_EDIT, edit),
];
